<template>
  <!-- <v-progress-circular
    v-if="loadingImage || !filePath"
    indeterminate
    color="primary"
  ></v-progress-circular> -->
  <v-dialog v-model="dialog" max-width="90%" :width="imageSize.width">
    <template v-slot:activator="{ on }">
      <v-skeleton-loader
        :loading="loadingImage || !filePath"
        transition="fade"
        class=""
        max-width="500"
        max-height="100"
        height="100"
        type="image"
      >
        <v-img
          v-on="on"
          class="excerpt-image"
          :src="filePath"
          contain
          :width="100 * imageSize.width / imageSize.height"
          max-width="500px"
          max-height="100px"
          position="left center"
        ></v-img
      ></v-skeleton-loader>
    </template>

    <v-card>
      <v-img :src="downloadUrl || filePath"></v-img>
    </v-card>
  </v-dialog>
</template>

<script>
import fb from '@/firebaseConfig';

export default {
  props: ['fileRef', 'downloadUrl'],
  data() {
    return {
      filePath: false,
      loadingImage: false,
      imageSize: { height: 100, width: 100 },
      dialog: false
    };
  },
  mounted() {
    this.setFilePath();
  },
  watch: {
    filePath: function(n) {
      const img = new Image();
      const that = this;
      img.onload = function() {
        that.imageSize = { height: this.height, width: this.width };
      };
      img.src = n;
    }
  },
  methods: {
    async setFilePath() {
      if (this.downloadUrl) return (this.filePath = this.downloadUrl);
      this.loadingImage = true;
      let url;
      try {
        const fbFileRef = fb.storage.ref().child(this.fileRef);
        url = await fbFileRef.getDownloadURL();
      } catch (e) {
        console.log(e);
        url = '';
      }

      this.loadingImage = false;
      this.filePath = url;
    }
  }
};
</script>

<style>
.excerpt-image {
  cursor: zoom-in;
}
</style>
